import { render } from "./ReminderResultListPage.vue?vue&type=template&id=b3955dc0&scoped=true"
import script from "./ReminderResultListPage.vue?vue&type=script&lang=js"
export * from "./ReminderResultListPage.vue?vue&type=script&lang=js"

import "./ReminderResultListPage.vue?vue&type=style&index=0&id=b3955dc0&scoped=true&lang=css"
import "./ReminderResultListPage.vue?vue&type=style&index=1&id=b3955dc0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3955dc0"]])

export default __exports__